module.exports = __webpack_public_path__ + "img/ds-15.5db4353d.gif";